"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nodeDisplayNameMatches = void 0;

var _getComponentName = _interopRequireDefault(require("react-utils/getComponentName"));

/**
 * @param {ReactElement} node
 * @param {RegExp} regex
 * @returns {Boolean} - true if the node has a displayName that matches the given regex
 */
var nodeDisplayNameMatches = function nodeDisplayNameMatches(node, regex) {
  return !!(node && (0, _getComponentName.default)(node.type).match(regex));
};

exports.nodeDisplayNameMatches = nodeDisplayNameMatches;